import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export type LoadingStyle = 'pulse' | 'bounce' | 'spinner' | 'dots' | 'skeleton' | 'wave';

export const LOADING_STYLES: { id: LoadingStyle; label: string; description: string }[] = [
  { id: 'pulse', label: 'Logo Pulse', description: 'Logo dengan efek pulse (default)' },
  { id: 'bounce', label: 'Logo Bounce', description: 'Logo dengan efek memantul' },
  { id: 'spinner', label: 'Circular Spinner', description: 'Lingkaran berputar dengan logo di tengah' },
  { id: 'dots', label: 'Animated Dots', description: 'Tiga titik berkedip bergantian' },
  { id: 'skeleton', label: 'Progress Bar', description: 'Bar progres animasi horizontal' },
  { id: 'wave', label: 'Wave Effect', description: 'Logo dengan gelombang efek ripple' },
];

const CACHE_KEY = 'cached_loading_style';

export const useLoadingStyle = () => {
  const [style, setStyle] = useState<LoadingStyle>(() => {
    const cached = localStorage.getItem(CACHE_KEY);
    return (cached as LoadingStyle) || 'pulse';
  });

  useEffect(() => {
    const fetch = async () => {
      const { data } = await supabase
        .from('app_settings')
        .select('loading_style')
        .eq('id', 'main')
        .single() as any;
      if (data?.loading_style) {
        setStyle(data.loading_style as LoadingStyle);
        localStorage.setItem(CACHE_KEY, data.loading_style);
      }
    };
    fetch();
  }, []);

  return style;
};
